// App name: GENERAL PURPOSE
// Description: Header, menu, panel
//

const GeneralApp = (function ($) {

  // variables
  let _self = $(this);
  let _body = $('body');
  let _htmlbody = $('html, body');
  let _btnHamburger = $('.hamburger');
  let _fixedItems = $('.fixednav-item');
  let _st = _self.scrollTop();
  let _window = $(window);
  let _menuAnchor = $('#sticky-sidebar-widget_nav_menu');
  var _lastScrollTop = 0;
  let _lang = $('.language-menu');
  let _chooseLang = $('.choose-lang');
  let _footer = $('.footer');
  let _stickyEl = $('.js-sticky');
  let _downloadEl = $('.js-download');

  var stickyPosTop = 0,
      stickyHeight = 0;

  if(_stickyEl.length) {
    stickyPosTop = _stickyEl.offset().top;
    stickyHeight = _stickyEl.outerHeight();
  }

  // init
  function init() {

    // hamburger handle
    hamburgerHandle();
    fixedItemClickHandle();
    menuAnchorHandle();
    // smoothScroll();
    activeLanguage();
    pageUp();
    showHidePageUp();
    addDownloadButton();
    addDownloadAttr();

    // window scrolling
    window.onscroll = function() {
      _st = $(this).scrollTop();
      stickyHeaderHandle();
      showHidePageUp();
      stickyPartHandle();
    }
  }

  //function name
  function hamburgerHandle() {
    _btnHamburger.on('click', function() {
      hamburgerToggleHandle();
    })
    _menuAnchor.find('.sub-menu .menu-item a').on('click', function(){
      hamburgerToggleHandle();
    })
  }

  function hamburgerToggleHandle() {
    _body.toggleClass('show-panel');
    if (_body.hasClass('show-panel') === false) {
      rescroll = _body.css('top').replace(/-|px/g, '');
      _htmlbody.scrollTop(rescroll);
    } else {
      _body.css('top', -_st);
    }
  }

  function fixedItemClickHandle() {
    _fixedItems.each(function() {
      let self = $(this);
      self.on('click', function(e) {
        e.preventDefault();
        _body.toggleClass('show-panel')
      })
    })
  }

  function menuAnchorHandle() {
    var _uri = window.location.href.split("#")[0];
    _menuAnchor.find('.sub-menu .menu-item a').each(function() {
      var _href = $(this).attr('href');
      if (_href.toLowerCase().indexOf(_uri) >= 0) {
        _href = _href.replace(_uri,'');
        $(this).attr('href', _href);
      }
    })
  }

  function stickyHeaderHandle() {
    if(_body.hasClass('show-panel') === false){
      if (_st > _lastScrollTop && _st > 0) {
        _body.removeClass('up');
      } else {
        _body.addClass('up');
      }
    }
    _lastScrollTop = _st;
  }

  function smoothScroll() {
    $('a[href^="#"]').on('click', function (e) {
      console.log('click href');
      var headerh = 70;
      if(_stickyEl.length) {
        headerh = 70 + 105;
      }

      e.preventDefault();
      var target = this.hash,
          $target = $(target),
          target_pos = $target.offset().top;

      setTimeout(function() {
        $('html, body').stop().animate({
          'scrollTop': target_pos - headerh
        }, 300, 'swing', function () {});
      }, 1);
    });
  }

  function activeLanguage() {
    //sp
    _lang.find('li.current-lang a').attr('href', 'javascript:void(0)');
    _lang.find('li').on('click', function(){
      $(this).closest('.language-menu').toggleClass('active')
    })

    //pc
    _chooseLang.find('.the-lang')
    .text(_lang.find('li.current-lang a').html())
    .on('click', function(){
      $(this).siblings('.language-menu').toggleClass('active');
    })

    _chooseLang.find('.the-lang').on('click', function() {
      $(this).toggleClass('active');
    });
  }

  function showHidePageUp() {
    if(_st > 100) {
      // $('.page-btns').addClass('active');
      $('.page-btns').show();
    } else {
      $('.page-btns').hide();
    }

    var footerPos = _footer.offset().top;
    var footerHeight = _footer.outerHeight();

    if (_window.scrollTop() +  _window.height() >= footerPos) {
      $(".page-btns").addClass("bottom");
      $(".page-btns").css('bottom', footerHeight + 20);
    } else{
      $(".page-btns").removeClass("bottom");
      $(".page-btns").css('bottom', '');
    }
  }

  function pageUp() {
    $('.js-totop').on('click', function () {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
      return false;
    });
  }

  function stickyPartHandle() {
    if(_stickyEl.length) {
      if(_st >= stickyPosTop - 69) {
        _body.addClass('has-sticky').css('padding-top', stickyHeight);
        if( !_stickyEl.hasClass('sticky') ) {
          _stickyEl.addClass('sticky');
          console.log('sticky added');

        }
      } else {
        _body.removeClass('has-sticky').css('padding-top', '');
        _stickyEl.removeClass('sticky');
      }
    }
  }

  function addDownloadAttr() {
    // if(_downloadEl.find('.gallery-item a').length) {
    //   _downloadEl.find('.gallery-item a').attr('download', '')
    // }

    if(_downloadEl.find('.gallery-item a.btn-download-img').length) {
      _downloadEl.find('.gallery-item a.btn-download-img').attr('download', '')
    }
  }

  function addDownloadButton() {
    $('.js-download .gallery-item').each(function() {
      var downloadLink = $(this).find('.gallery-icon a:first-child').attr('href');
      // console.log(downloadLink);
      $(this).find('.gallery-icon').append('<a class="btn-download-img" href="' + downloadLink + '"></a>');
    });
  }

  return {
    init: init,
  };

})(jQuery);

jQuery('document').ready(function () {
  GeneralApp.init();
});

const GeneralAppOnLoad = (function ($) {

  // variables
  let _body = $('body');
  let _header = $('.header');
  let _footer = $('.footer');
  let _colorBar = $('.color-bar');
  let _stickyEl = $('.js-sticky');

  function init() {
    colorBar();
    triggerColorBarOnDocChangeHeight();
    smoothScrollOnLoad();

    window.onresize = function() {
      colorBar();
    }
  }

  function colorBar() {
    if(_colorBar.length) {
      var colorArr = ['#A7181F', '#7E6561', '#50536A', '#4A6525', '#7F966E', '#A39E6D', '#626757'];
      var headerHeight = _header.outerHeight();
      var footerHeight = _footer.outerHeight();
      // var colorBarHeight = _body.outerHeight() - headerHeight - footerHeight;
      var colorBarHeight = _body.outerHeight();
      var everyColorHeight = colorBarHeight/colorArr.length;
      var colorHTML = '';
      colorArr.forEach(function(item) {
        colorHTML += '<span style="background-color: '+item+';height: '+everyColorHeight+'px;display: block"></span>';
      })

      // console.log(colorBarHeight);
      setTimeout(function() {
        _colorBar.html(colorHTML)
        .css({
          'height' : colorBarHeight,
          // 'top' : headerHeight
          'top' : 0,
        })
      }, 100)
    }
  }

  function onElementHeightChange(elm, callback) {
    var lastHeight = elm.clientHeight, newHeight;

    (function run() {
      newHeight = elm.clientHeight;
      if (lastHeight != newHeight)
        callback(newHeight)
      lastHeight = newHeight

      if (elm.onElementHeightChangeTimer)
        clearTimeout(elm.onElementHeightChangeTimer)

      elm.onElementHeightChangeTimer = setTimeout(run, 100)
    })()
  }

  function triggerColorBarOnDocChangeHeight() {
    onElementHeightChange(document.body, function(h) {
      colorBar();
    })
  }

  function smoothScrollOnLoad() {
    var headerh = 70;
    if(_stickyEl.length) {
      headerh = 70 + 105;
    }

    setTimeout(function() {
      var str = location.hash;
      if(str != '' && $(str).length != 0) {
        var n = str.replace("_temp","");
        // console.log('scroll top: ');
        // console.log($(n).offset().top - headerh);
        $('html,body').animate({scrollTop:$(n).offset().top - headerh}, 300);
      }
    }, 300);
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(window).on('load', function() {
  GeneralAppOnLoad.init();
})
